import React from "react";
import HoverImageLinks from "../components/pubilcationsComponents/imageLink";
import "../fonts.css";

function Publications() {
  document.body.style = "background: black;";
  return (
    <div>
      <HoverImageLinks />
    </div>
  );
}

export default Publications;